import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UserProfile } from '../../../model/src/lib/user-profile.model';
import { isNullOrEmpty } from '../../../util/src/lib/is-null-or-empty';
import { AuthenticationService } from '../services/authentication.service';
import { StorageService } from '../services/storage.service';

@Injectable()
export class LoginGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private storageService: StorageService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.authenticationService.isAuthenticated) {
      if (isNullOrEmpty(this.authenticationService.currentUserValue)) {
        // get user profile from local or session storage
        const userProfile = (this.storageService.local.getItem(
          this.storageService.keys.UserProfile
        ) ||
          this.storageService.session.getItem(
            this.storageService.keys.UserProfile
          )) as UserProfile;
        if (!isNullOrEmpty(userProfile)) {
          return this.authenticationService
            .initLoginUserData(userProfile.userNo)
            .pipe(
              tap((isSuccess) => {
                if (isSuccess) {
                  this.router.navigate(['/']);
                }
              })
            );
        }
      }
      this.router.navigate(['/']);
      return false;
    }
    return true;
  }
}
